<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Create Editing Workspace</div>

    <div class="modal-body cl-form">
      <p>
        Create an editing workspace for the selected content.
        This will create an EBS volume and stage the content for remote editing.
      </p>

      <label class="form-label">Selected Items ({{ items.length }})</label>
      <ul class="item-list">
        @for (item of items; track item.id) {
          <li>{{ item.name }}</li>
        }
      </ul>

      <form id="create-workspace-form" [formGroup]="form">
        <label for="availabilityZone" class="form-label">Region</label>
        <select
          id="availabilityZone"
          formControlName="availabilityZone"
          style="width: 100%"
          class="form-select"
        >
          @for (az of availabilityZones; track az.value) {
            <option [value]="az.value">{{ az.label }}</option>
          }
        </select>
        <p class="valid-feedback">
          Choose the region closest to the editor.
        </p>

        <label for="mountPoint" class="form-label">Workspace Name</label>
        <input
          type="text"
          id="mountPoint"
          formControlName="mountPoint"
          placeholder="e.g., my-workspace"
          style="width: 100%"
          required
          [class.invalid]="form.get('mountPoint')?.invalid && form.get('mountPoint')?.touched"
        />
        @if (form.get('mountPoint')?.errors?.['required'] && form.get('mountPoint')?.touched) {
          <p class="invalid-feedback">Workspace name is required.</p>
        } @else if (form.get('mountPoint')?.errors?.['maxlength'] && form.get('mountPoint')?.touched) {
          <p class="invalid-feedback">Maximum 32 characters allowed.</p>
        } @else if (form.get('mountPoint')?.errors?.['pattern'] && form.get('mountPoint')?.touched) {
          <p class="invalid-feedback">Cannot contain \ / : * ? " &lt; &gt; | $ `</p>
        } @else {
          <p class="valid-feedback">A label for identifying the workspace (max 32 chars).</p>
        }

        <label for="message" class="form-label">Message for the editor (optional)</label>
        <textarea
          id="message"
          formControlName="message"
          placeholder="Notes or instructions for the editor"
          rows="3"
          style="width: 100%"
        ></textarea>
      </form>
    </div>

    <div class="modal-footer">
      <app-form-footer label="Create workspace" (action)="createEditingWorkspace($event)">
        <button footerStart type="button" class="btn cl-color-secondary it-cancel" (click)="dialogRef.close()"><span>Cancel</span></button>
      </app-form-footer>
    </div>
  </div>
</div>